export const baseOrderDelivery = {
	id: "",
	business_id: "",
	estate_parent_id: "",
	estate_id: "",
	dealer_id: "",
	rut_dealer: "",
	type_currency_id: "1",
	delivery_number: "",
	date_orders_delivery: "",
	orders_code: [],
	orders_sale_code: [],
	items: [],
	documents: [],
};

export const customStyles = {
	control: (base, state) => ({
		...base,
		height: "1px",
		boxShadow: state.isFocused ? null : null,
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
};

export const baseUnitCreate = [
	{
		value: "u1",
		label: "Un",
	},
	{
		value: "c1",
		label: "cc",
	},
	{
		value: "c1000",
		label: "L",
	},
	{
		value: "g1",
		label: "g",
	},
	{
		value: "g1000",
		label: "Kg",
	},
	{
		value: "g1000000",
		label: "Tn",
	},
];
